import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskScheduleRescheduled_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskScheduleRescheduled_ActivityLogFragment;
}

const ActivityLogTaskScheduleRescheduled: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.rescheduledSchedule"
    />
  );
};

ActivityLogTaskScheduleRescheduled.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskScheduleRescheduled_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskScheduleRescheduled;
